import { render, staticRenderFns } from "./addManage.vue?vue&type=template&id=bc4a2d60&scoped=true&"
import script from "./addManage.vue?vue&type=script&lang=js&"
export * from "./addManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a2d60",
  null
  
)

export default component.exports